/*
 * Created by: cparaschiv
 * Date: 07.05.2013, 16:16
 */

/** @module TS.UI */
/** @name TS.UI */
TS.UI = TS.UI || {};

(function(){

    var _maskTask = null;

    /** exports */
    $.extend(TS.UI, {
        defaultPopupWidth: 640,
        defaultPopupHeight: 480,
        models: new TS.Stack(),
        rootModel: null,

        //see http://fgnass.github.io/spin.js for options explanation
        spinnerCfg: {
            lines: 12,
            length: 20,
            width: 5,
            radius: 15,
            trail: 60,
            speed: 1.0
        },

        _autoWindowHeight: function($elem) {
            $elem && $elem.height('auto');
        },

        showDomain: function(opts, callback){
            var ui = TS.UI,
                win,
				popupElId = 'popup-container' + TS.UI.models.stack.length,
                model = opts.viewModel || {},
                popupWidth = opts.popupWidth || $(window).width() * 0.8,
                popupHeight = opts.popupHeight || $(window).height() * 0.8,
                popupEl;

            TS.UI.Mask.show(true);
            // get new model from server (non-observable)
            // merge properties with model (TODO)
            // convert model to observable
            // push to navigation stack

            popupEl = $('#' + popupElId)[0];
            if (!popupEl){
                // create a div as a placeholder for window
            	popupEl = $('<div id="' + popupElId + '"></div>');
            }

            var onWindowClose = function(e) {
                var widget;
                // intercept only user-triggered events (i.e.: clicked the upper-right 'X' button)
                if (e.userTriggered) {
                    TS.trace('Before window close');

                    if (model.canClose && (model.canClose() === false)){
                        e.preventDefault();
                        return;
                    }

                    if (model.close) {
                    	//do not destroy widget, see onModelClose handler for model close event.
                    	e.preventDefault();
                    	model.close(true, true);
                    } else {
                    // destroy the window - cleans up the DOM
                    widget = $(popupEl).data("kendoWindow");
                    if (widget) {
                        widget.destroy();
                    }
                    }
                }
            };

            var onRefresh = function(){
                var elem, footer, header, parent;

                TS.UI.Mask.hide();

                if (!TS.UI.popupModel){
                    return;
                }

                if (model) {
                    TS.UI.popupModel._merge(model);
                }

                model = TS.UI.popupModel;

                win = win || $(popupEl).data('kendoWindow');
                elem = $(win.element);
                parent = elem.parent();

                // move the commands panel one level up in the hierarchy
                // to make them appear at the bottom of the window
                footer = elem.find("#commands")[0];
                if (footer) {
                    footer.remove();
                    parent.append(footer);
                }

                // the window title is a <span> element, so use the 'html' binding
                header = parent.find('.k-window-title')[0];
                if (header){
                    $(header).attr('data-bind', 'html: title');
                }

            	//floatable navigator
                var floatableNavBar = elem.find('.nav-block-float');
                if (floatableNavBar.length) {
                	elem.find('#burgerMenu').show();
                	floatableNavBar.click(function () {
                		floatableNavBar.removeClass('show');
                	});
                }

            	//top floating elements
                ts.topFloatingElement('.top-floating-element');

                TS.bind(model, parent[0]);
        		//TS.UI._autoWindowHeight(parent);
        		parent && parent.height(popupHeight);

                TS.scrollNav.initialize(elem);

                var onModelClose = function(e){
                    TS.trace('OnModelClose');
                    // cleanup the the stack
                    TS.UI.models.pop();
        			win.close();
                    win.destroy();
                };

                var onModelClosing = function (e) {
                	TS.trace('OnModelClosing');
                	if (opts.ignoreResponse) {
                		e.ignoreResponse = true;
                	}
                };

                // this must be the last handler, as it pops the model from the stack
                // leaving all subsequent handlers with no model to observe
                model.on('close', onModelClose);
                model.on('closing', onModelClosing);

                TS.UI.models.push(model);

                callback && callback(model);
            };

            var onError = function(e){
                TS.Log.warn('Error showing model. ' + TS.Log.getXHRInfo(e.xhr));
                TS.Notify.error('An error has occured. Please contact your administrator.');
            };

            var windowOptions = {
                appendTo: $('body'),

                width: popupWidth,
                height: popupHeight,

                modal: true,
                resizable: true,
                draggable: true,
                title: 'Edit',
                visible: true,

                content: {
                    url: opts.url,
                    data: opts.data
                },

                refresh: onRefresh,
                error: onError,
                close: onWindowClose,

                resize: function() {
                    var x = new Error();
                    TS.Log.warn(x.stack);
                }
            };

            var windowOptionsOverride = $.isFunction(opts.windowOptionsOverride) 
                ? opts.windowOptionsOverride(windowOptions)
                : (opts.windowOptionsOverride || {});

            $.extend(windowOptions, windowOptionsOverride);
            win = $(popupEl).kendoWindow(windowOptions);
            win = win.data('kendoWindow');
            win.center().open();

            return model;
        },

        /**
         * Provides a consistent mean for navigating to a certain URL.
         * @param url {String} URL to navigate to
         * @static
         */
        navigateTo: function(url){
            window.location.href = url;
        },

        /**
         * <p>Covers the user interface with a transparent mask and a progress indicator, preventing the user from interacting with UI elements.</p>
         * <p>However, the masking is delayed so that only long operations will trigger it (otherwise it would be annoying).
         * The delay can be configured via TS.Constants.ShowIndicatorDelay.</p>
         * @static
         */
        maskDelayed: function(){
            //TS.log('maskDelayed');

            if (_maskTask) {
                //TS.log('maskDelayed - already masking...');
                return;
            }
            // unmask was cancelled before, clear the 'false' flag and return
            //if (_maskTask === false) {
            //    TS.log('maskDelayed - was cancelled, clear flag & return');
            //    _maskTask = null;
            //    return;
            //}

            _maskTask && _maskTask.cancel();
            _maskTask = new TS.util.DelayedTask(function() {
            	TS.UI.Mask.show();
            });
            _maskTask.delay(TS.Constants.ShowIndicatorDelay);
        },

        /**
         * <p>Covers the user interface with a transparent mask and a progress indicator, preventing the user from interacting with UI elements.</p>
         * <p>The UI is covered immediately.</p>
         * @static
         */
        mask: function(){
            //TS.log('mask');
            var maskHeight = $(document).height(),
                maskWidth = $(document).width(),
                $loadMask = $('#load-mask');

            $loadMask.css({'width': maskWidth, 'height': maskHeight});
            $loadMask.show();
            $loadMask.spin(TS.UI.Mask.config);
            $loadMask.find('.spinner').css({'position':'fixed', 'left':'50%', 'top':'50%'});
        },

        /**
         * <p>Removes the transparent mask from the user interface.</p>
         * @static
         */
        unmask: function(){
            //TS.log('unmask');
            var $loadMask;

            if (_maskTask) {
                //TS.log('unmask - cancel');
                _maskTask.cancel();
                _maskTask = false;
            }

            $loadMask = $('#load-mask');
            $loadMask.spin(false);
            $loadMask.hide();
        },


        showSessionExpired: function(redirectUrl){
            var c = TS.cultures.current;
            TS.MsgBox.show(c.sessionExpired.Title, c.sessionExpired.Message, function(){
                if (redirectUrl){
                    TS.UI.navigateTo(redirectUrl);
                }
            });
        }
    });

    TS.viewDomain = TS.UI.viewDomain;
})();